export default function validate(formProps) {
    const errors = {};

    if (!formProps.label_type_id) {
        errors.label_type_id = 'Label Type is required! Please select a label type for your label!';
    }

    if (!formProps.display_name) {
        errors.display_name = 'Name field is required! Please enter a name for your label!';
    }

    return errors;
}


// WEBPACK FOOTER //
// ./src/containers/labels/forms/validation.js